// @flow
'use strict';

import * as React from 'react';

import type { IIbsCbsEImpostoSeletivo } from './types';

import RowDetalhes from '../row_detalhes';
import ColumnDetalhes from '../column_detalhes';

type IbsCbsEImpostoSeletivoProps = {
  ibsCbsEImpostoSeletivo : IIbsCbsEImpostoSeletivo,
};

export default function IbsCbsEImpostoSeletivo({ ibsCbsEImpostoSeletivo } : IbsCbsEImpostoSeletivoProps) {
  return (
      <div id="table-ibs-cbs-imp-seletivo">
        <h3>IBS / CBS e Imposto Seletivo</h3>

        <h4>Informações do Imposto Seletivo (IS)</h4>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="cstImpostoSeletivo" width="25%">CST</ColumnDetalhes>
          <ColumnDetalhes field="codClassTribImpostoSeletivo" width="25%">Cód. classificação tributária</ColumnDetalhes>
          <ColumnDetalhes field="valorBcImpostoSeletivo" width="25%">Base cálculo do IS</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaImpostoSeletivo" type="percentual" width="25%">Alíquota</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="aliquotaEspecificaImpostoSeletivo" type="percentual" width="25%">Alíquota esp un.
            medida</ColumnDetalhes>
          <ColumnDetalhes field="unidadeImpostoSeletivo" width="25%">Unidade de medida tributável</ColumnDetalhes>
          <ColumnDetalhes field="quantidadeImpostoSeletivo" width="25%">Quantidade tributável</ColumnDetalhes>
          <ColumnDetalhes field="valorIsImpostoSeletivo" width="25%">Valor do IS</ColumnDetalhes>
        </RowDetalhes>

        <h4>Informações do IBS e da CBS</h4>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="cstIbsCbs" width="25%">CST</ColumnDetalhes>
          <ColumnDetalhes field="codClassTribIbsCbs" width="25%">Cód. classificação tributária</ColumnDetalhes>
          <ColumnDetalhes field="indicadorDoacaoIbsCbs" width="25%">Indicador de doação</ColumnDetalhes>
          <ColumnDetalhes field="valorBcIbsCbs" width="25%">BC do IBS e CBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>IBS para a UF</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="aliquotaIbsUnidFed" type="percentual" width="25%">Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="percDiferimentoIbsUnidFed" type="percentual" width="25%">Perc. diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDiferimentoIbsUnidFed" type="moeda" width="25%">Valor diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorTribDevolvidoIbsUnidFed" type="moeda" width="25%">Valor tributo devolvido</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="percRedAliqCClassTribIbsUnidFed" type="percentual" width="25%">Perc. redução alíq.
            cClassTrib</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaEfetivaIbsUnidFed" type="percentual" width="25%">Alíquota efetiva</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsUnidFed" type="moeda" width="50%">Valor IBS UF</ColumnDetalhes>
        </RowDetalhes>

        <h5>IBS para o Município</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="aliquotaIbsMun" type="percentual" width="25%">Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="percDiferimentoIbsMun" type="percentual" width="25%">Perc. diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDiferimentoIbsMun" type="moeda" width="25%">Valor diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorTribDevolvidoIbsMun" type="moeda" width="25%">Valor tributo devolvido</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="percRedAliqCClassTribIbsMun" type="percentual" width="25%">Perc. redução alíq.
            cClassTrib</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaEfetivaIbsMun" type="percentual" width="25%">Alíquota efetiva</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMun" type="moeda" width="50%">Valor IBS município</ColumnDetalhes>
        </RowDetalhes>

        <h5>Total do IBS</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="valorIbs" type="moeda" width="50%">Valor do IBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>Informações da CBS</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="aliquotaCbs" type="percentual" width="25%">Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="percDiferimentoCbs" type="percentual" width="25%">Perc. diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDiferimentoCbs" type="moeda" width="25%">Valor diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorTribDevolvidoCbs" type="moeda" width="25%">Valor tributo devolvido</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="percRedAliqCClassTribCbs" type="percentual" width="25%">Perc. redução alíq.
            cClassTrib</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaEfetivaCbs" type="percentual" width="25%">Alíquota efetiva</ColumnDetalhes>
          <ColumnDetalhes field="valorCbs" type="moeda" width="50%">Valor CBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>Informações da Tributação Regular</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="cstIbsCbsTribReg" width="25%">CST IBS e CBS</ColumnDetalhes>
          <ColumnDetalhes field="codClassTribIbsCbsTribReg" width="25%">Cód Class. tributária IBS e CBS</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaIbsUnidFedTribReg" type="percentual" width="25%">Alíquota IBS da UF</ColumnDetalhes>
          <ColumnDetalhes field="tribIbsUnidFedTribReg" type="moeda" width="25%">Tributo do IBS da UF</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="aliquotaIbsMunTribReg" type="percentual" width="25%">Alíquota IBS do município</ColumnDetalhes>
          <ColumnDetalhes field="tribIbsMunTribReg" type="moeda" width="25%">Tributo do IBS do município</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaCbsTribReg" type="percentual" width="25%">Alíquota CBS</ColumnDetalhes>
          <ColumnDetalhes field="tribCbsTribReg" type="moeda" width="25%">Tributo da CBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>Informações da Composição do IBS/CBS em Compras Governamentais</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="aliquotaIbsUnidFedComprasGov" type="percentual" width="33%">Alíquota IBS da UF</ColumnDetalhes>
          <ColumnDetalhes field="tribIbsUnidFedComprasGov" type="moeda" width="33%">Tributo do IBS da UF</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaIbsMunComprasGov" type="percentual" width="33%">Alíquota IBS do município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="tribIbsMunComprasGov" type="moeda" width="33%">Tributo do IBS do município</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaCbsComprasGov" type="percentual" width="33%">Alíquota CBS</ColumnDetalhes>
          <ColumnDetalhes field="tribCbsComprasGov" type="moeda" width="33%">Tributo do CBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>Informações IBS/CBS em operações com imposto monofásico</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="qtdTribImpostoMonofasico" width="25%">Quantidade trib monofasia</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaAdRemIbsImpostoMonofasico" type="percentual" width="25%">Alíquota ad rem do IBS</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaAdRemCbsImpostoMonofasico" type="percentual" width="25%">Alíquota ad rem da CBS</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMonoImpostoMonofasico" type="moeda" width="25%">Valor IBS monofásico</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="valorCbsMonoImpostoMonofasico" type="moeda" width="25%">Valor CBS
            monofásica</ColumnDetalhes>
          <ColumnDetalhes field="qtdTribRetencaoImpostoMonofasico" width="25%">Quantidade trib suj
            retenção</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaAdRemIbsRetencaoImpostoMonofasico" type="percentual" width="25%">Alíquota ad
            rem IBS suj retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsRetencaoImpostoMonofasico" type="moeda" width="25%">Valor IBS monofásico su
            retenção</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="aliquotaAdRemCbsRetencaoImpostoMonofasico" type="percentual" width="25%">Alíquota ad
            rem CBS su retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsRetencaoImpostoMonofasico" type="moeda" width="25%">Valor CBS mono suj
            retenção</ColumnDetalhes>
          <ColumnDetalhes field="qtdTribRetAnterImpostoMonofasico" width="25%">Qtd trib ret anteriormente</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaAdRemIbsRetAnterImpostoMonofasico" type="percentual" width="25%">Alíq. ad rem
            IBS ret ant</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="valorIbsRetAnterImpostoMonofasico" type="moeda" width="25%">Valor IBS ret
            anteriormente</ColumnDetalhes>
          <ColumnDetalhes field="aliquotaAdRemCbsRetAnterImpostoMonofasico" type="percentual" width="25%">Alíq. ad rem
            CBS ret ant</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsRetAnterImpostoMonofasico" type="moeda" width="25%">Valor CBS ret
            anteriormente</ColumnDetalhes>
          <ColumnDetalhes field="percDifIbsImpostoMonofasico" type="percentual" width="25%">Perc. diferim. imp. monof.
            IBS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo } className="no-margin-bottom">
          <ColumnDetalhes field="ibsMonDiferImpostoMonofasico" type="moeda" width="25%">IBS monofásico
            diferido</ColumnDetalhes>
          <ColumnDetalhes field="percDifCbsImpostoMonofasico" type="percentual" width="25%">Perc. diferim. imp. monof.
            CBS</ColumnDetalhes>
          <ColumnDetalhes field="cbsMonDiferImpostoMonofasico" type="moeda" width="25%">CBS monofásica
            diferida</ColumnDetalhes>
          <ColumnDetalhes field="totalIbsMonoImpostoMonofasico" type="moeda" width="25%">Total IBS
            monofásico</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="totalCbsMonoImpostoMonofasico" type="moeda" width="100%">Total CBS monofásica</ColumnDetalhes>
        </RowDetalhes>

        <h5>Transferências de Crédito</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="valorIbsTransfCredito" type="moeda" width="50%">Valor IBS a ser transferido</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsTransfCredito" type="moeda" width="50%">Valor CBS a ser transferida</ColumnDetalhes>
        </RowDetalhes>

        <h5>Ajuste de Competência</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="anoMesAjusteCompetencia" width="33%">Ano/mês do período de apuração</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsAjusteCompetencia" type="moeda" width="33%">Valor IBS</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsAjusteCompetencia" type="moeda" width="33%">Valor CBS</ColumnDetalhes>
        </RowDetalhes>

        <h5>Estorno de Crédito</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="valorIbsEstornoCredito" type="moeda" width="50%">Valor IBS a ser estornado</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsEstornoCredito" type="moeda" width="50%">Valor CBS a ser estornada</ColumnDetalhes>
        </RowDetalhes>

        <h5>Crédito Presumido da Operação</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="valorBcCredPresumOperacao" type="moeda" width="50%">Valor BC crédito presumido</ColumnDetalhes>
          <ColumnDetalhes field="codClassifCredPresumOperacao" width="50%">Cód. classificação crédito presumido</ColumnDetalhes>
        </RowDetalhes>

        <h5>Crédito Presumido IBS</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="percCredPresumIbs" type="percentual" width="33%">Percentual do crédito presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCredPresumIbs" type="moeda" width="33%">Valor crédito presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCondSuspensivaCredPresumIbs" type="moeda" width="33%">Valor crédito presumido
            cond suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h5>Crédito Presumido CBS</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="percCredPresumCbs" type="percentual" width="33%">Percentual do crédito presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCredPresumCbs" type="moeda" width="33%">Valor crédito presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCondSuspensivaCredPresumCbs" type="moeda" width="33%">Valor crédito presumido
            cond suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h5>Apropriação de Crédito Presumido de IBS sobre saldo ZFM</h5>
        <RowDetalhes data={ ibsCbsEImpostoSeletivo }>
          <ColumnDetalhes field="anoMesCredPresumIbsSobSaldoZfm" width="33%">Ano/mês do período de
            apuração</ColumnDetalhes>
          <ColumnDetalhes field="tipClassifCredPresumIbsSobSaldoZfm" width="33%">Tipo classif. para
            cálculo</ColumnDetalhes>
          <ColumnDetalhes field="valorCredPresumIbsSobSaldoZfm" type="moeda" width="33%">Valor crédito pres. sobre saldo
            devedor</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}